export default __webpack_public_path__ + "static/media/92t.ed4d7061.jpg";